import React from 'react';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import Form from '../Form';
import InputAddressStreet from '../InputAddressStreet';
import InputAddressSecondary from '../InputAddressSecondary';
import InputAddressCity from '../InputAddressCity';
import InputAddressState from '../InputAddressState';
import InputAddressZipCode from '../InputAddressZipCode';
import ButtonPrimary from '../ButtonPrimary';

import useForm from './useForm';
import usePrequal from '../../resources/prequal/usePrequal';

const Address = () => {
  useRUMView('address');
  const { data: prequal } = usePrequal();

  const {
    form,
    handleSubmit,
    isSubmitting,
  } = useForm();

  return (
    <Screen header={`Nice to meet you, ${prequal?.firstName}. What's your home address?`}>
      <Form form={form} onSubmit={handleSubmit}>
        <InputAddressStreet prefill={prequal.street} />
        <InputAddressSecondary prefill={prequal.secondary} />
        <InputAddressCity prefill={prequal.city} />
        <InputAddressState prefill={prequal.state} />
        <InputAddressZipCode prefill={prequal.zipCode} />
        <ButtonPrimary isLoading={isSubmitting}>
          Continue
        </ButtonPrimary>
      </Form>
    </Screen>
  );
};

export default Address;
